export default __webpack_public_path__ + "static/media/subscribe_img.fd3f2f33.png";